import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import faqModel from "models/faq.model";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import Swal from "sweetalert2";
import enquiriesModal from "models/enquiries.modal";
import moment from "moment";
import levelModal from "models/level.modal";

const EditEnquriStudentDetails = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const [dataList, setDataList] = useState(null);
  const navigate = useNavigate();
  const parmas = useParams();

  const handleSubmitEditFAQ = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("id", parmas.id);
    // You can adjust the header configuration according to your API requirements
    faqModel
      .editFaqs(form)
      .then((response) => {
        helper.sweetalert.toast("Your Faqs Edit.", "success");
        navigate("/admin/fAQs");
        setAddsLoadig(false);
        // Display success message to the user
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  // const getListDataByid = () => {
  //   const data = {
  //     id: parmas?.id,
  //   };
  //   // Assuming '19' is the ID you want to send
  //   faqModel
  //     .listbyfaqsid(data)
  //     .then((response) => {
  //       setDataList(response.data.data);
  //       // console.log(response.data.data, "data");
  //     })
  //     .catch((error) => {
  //       // console.log(error);
  //     });
  // };

  // // console.log(parmas?.id, "params");
  // useEffect(() => {
  //   if (parmas.id != "") {
  //     getListDataByid();
  //   }
  // }, []);

  const [studentData, setStudentData] = useState();
  const [preferredTime, setPreferredTime] = useState("");

  const getListDataByStudentid = () => {
    const id = parmas?.sid;
    // Assuming '19' is the ID you want to send
    enquiriesModal
      .StudentDetails(id)
      .then((response) => {
        setStudentData(response.data);
        const timeIn24Hour = convertTimeTo24Hour(response.data?.preferrd_time);
        setPreferredTime(timeIn24Hour);
        // console.log(response.data.data, "data");
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  const convertTimeTo24Hour = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");

    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  };

  // Helper function to convert 24-hour time to 12-hour (AM/PM) format
  const convertTimeTo12Hour = (time24h) => {
    let [hours, minutes] = time24h.split(":");
    const modifier = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // Convert to 12-hour format
    return `${hours}:${minutes} ${modifier}`;
  };
  useEffect(() => {
    if (parmas.sid != "") {
      getListDataByStudentid();
    }
  }, []);

  console.log(studentData, "studentData");

  const [selectedGender, setSelectedGender] = useState("");

  const [selectedMode, setSelectedMode] = useState("");

  useEffect(() => {
    if (studentData?.gender) {
      setSelectedGender(studentData.gender);
      // setSelectedMode(dataList.mode)
    }
  }, [studentData]);

  const handleChangegender = (event) => {
    setSelectedGender(event.target.value);
  };
  // const handleChangeMode = (event) => {
  //   setSelectedGender(event.target.value);
  // };

  // select end time function
  const [preferrdTime, setpreferrdTime] = useState("");
  const handlePreferrdTimeChange = (event) => {
    const { value } = event.target;
    setpreferrdTime(value);
  };

  useEffect(() => {
    setpreferrdTime(studentData?.preferrd_time);
  }, [studentData]);

  const [DateofBirth, setDateofBirth] = useState();
  const handleChangeDateofBirth = (event) => {
    const { value } = event.target;
    setDateofBirth(value); // Update meetingDate state with the selected date
  };
  const formattedDate = moment(DateofBirth).format("DD/MM/YYYY");

  useEffect(() => {
    if (studentData?.dob) {
      const formattedDate = moment(studentData?.dob).format("YYYY-MM-DD");
      setDateofBirth(formattedDate);
    }
  }, [studentData]);

  console.log(DateofBirth, "DateofBirth");
  const [selectLevel, setSelectdLevel] = useState("");
  const handleSelectStatus = (id) => {
    setSelectdLevel(id);
  };
  const [ListLevel, setListLevel] = useState([]);
  const getListDataLevel = async () => {
    await levelModal
      .list()
      .then((result) => {
        if (result) {
          setListLevel(result?.data);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getListDataLevel();
  }, []);
  console.log("data-parms",parmas)
  const handleSubmiteditStudentDetails = (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("id", parmas.sid);
    form.append("level", selectLevel);
    const preferredTime = form.get("preferrd_time");
    const formattedTime = convertTimeTo12Hour(preferredTime);
    form.set("preferrd_time", formattedTime);
    // You can adjust the header configuration according to your API requirements
    enquiriesModal
      .editStudentDeatils(form)
      .then((response) => {
        getListDataByStudentid();
       
         navigate(`/admin/viewenquiry/${parmas.id}/${parmas.mid}`);

        helper.sweetalert.toast(response.data.message, "success");
      })
      .catch((error) => {
        helper.sweetalert.toast(error?.response?.data?.name[0], "error");
      });
  };
  
  return (
    <>
      <Container className="pt-7">
        {studentData && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">Edit Student</h3>
                </CardHeader>
                <CardBody>
                  <div>
                    <Form onSubmit={handleSubmiteditStudentDetails}>
                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">Student Name</Label>
                            <Input
                              style={{
                                border: "1px solid lightgrey",
                                padding: "6px 10px",
                                borderRadius: "6px",
                              }}
                              id="name"
                              name="name"
                              placeholder="Enter Student Name"
                              defaultValue={studentData?.name}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">Academic</Label>
                            <Input
                              id="Priority"
                              // name="priority"
                              disabled
                              type="text"
                              placeholder="Enter Academic"
                              defaultValue={studentData?.Academic}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">Board</Label>
                            <Input
                              id="Priority"
                              disabled
                              // name="priority"
                              type="text"
                              defaultValue={studentData?.Board}
                              placeholder="Enter Board"
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">Class Name</Label>
                            <Input
                              disabled
                              style={{
                                border: "1px solid lightgrey",
                                padding: "6px 10px",
                                borderRadius: "6px",
                              }}
                              id="name"
                              // name="question"
                              defaultValue={studentData?.Class}
                              placeholder="Enter Class Name"
                            />
                          </FormGroup>
                        </Col>

                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">Subject</Label>
                            <Input
                              disabled
                              id="Priority"
                              // name="priority"
                              type="text"
                              defaultValue={studentData?.subjects?.map(
                                (item) => item
                              )}
                              placeholder="Enter Subject Name"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">Gender</Label>
                            <Input
                              id="forType"
                              type="select"
                              name="gender"
                              defaultValue={studentData?.gender}
                              onChange={handleChangegender}
                            >
                              <option value="">Select Gender </option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Other">other</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">Date Of Birth</Label>
                            <Input
                              style={{
                                border: "1px solid lightgrey",
                                padding: "6px 10px",
                                borderRadius: "6px",
                              }}
                              id="name"
                              type="date"
                              name="question"
                              value={DateofBirth}
                              onChange={handleChangeDateofBirth}
                              placeholder="Enter Class Name"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">
                              School/College/Unexpected Name
                            </Label>
                            <Input
                              id="Priority"
                              name="school_name"
                              type="text"
                              defaultValue={studentData?.school_name}
                              placeholder="Enter School/College/Unexpected Name"
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="preferrd_time">
                              Preferred Time Duration{" "}
                              {studentData?.preferrd_time}
                            </Label>
                            <Input
                              style={{
                                border: "1px solid lightgrey",
                                padding: "6px 10px",
                                borderRadius: "6px",
                              }}
                              id="preferrd_time"
                              type="time"
                              defaultValue={preferredTime}
                              name="preferrd_time"
                              placeholder="Enter Preferred Time Duration"
                            />
                          </FormGroup>
                        </Col>

                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">Tuition Tenure</Label>
                            <Input
                              id="Priority"
                              name="term"
                              type="text"
                              defaultValue={studentData?.term}
                              placeholder="Enter Tuition Tenure"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="exampleEmail">
                              Location Preference
                            </Label>
                            <Input
                              id="Priority"
                              name="location"
                              type="text"
                              defaultValue={studentData?.location}
                              placeholder="Enter Location Preference"
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="exampleEmail">Location City </Label>
                            <Input
                              style={{
                                border: "1px solid lightgrey",
                                padding: "6px 10px",
                                borderRadius: "6px",
                              }}
                              defaultValue={studentData?.city}
                              id="name"
                              type="text"
                              name="city"
                              placeholder="Enter Location City "
                            />
                          </FormGroup>
                        </Col>

                        {/* <Col md={6}>
                          <FormGroup>
                            <Label for="exampleEmail">Tutor Level</Label>
                            <Input
                              id="Priority"
                              name="priority"
                              type="text"
                              defaultValue={studentData?.tutor_level}
                              placeholder="Enter Tutor Level"
                            />
                          </FormGroup>
                        </Col> */}

                        <Col md={6}>
                          <FormGroup>
                            <Label for="exampleEmail">Level</Label>
                            <Input
                              id="forType"
                              type="select"
                              onChange={(e) => {
                                handleSelectStatus(e.target.value, "board");
                              }}
                            >
                              <option value="">select Option</option>
                              {ListLevel &&
                                ListLevel.map((item, name) => {
                                  return (
                                    <option value={item.id}>
                                      {item.name}{" "}
                                    </option>
                                  );
                                })}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          color="secondary"
                          to={`/admin/viewenquiry/${parmas.mid}/${parmas.id}`}
                          tag={Link}
                        >
                          Cancel
                        </Button>

                        <Button
                          color="primary"
                          type="submit"
                          style={{
                            float: "right",
                            marginLeft: "5%",
                            backgroundColor: "#080278",
                            color: "white",
                            border: "none",
                          }}
                          // onClick={getListDataByid}
                        >
                          Edit
                        </Button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Row>
        )}
      </Container>
    </>
  );
};

export default EditEnquriStudentDetails;
